import React from 'react'
import YouTube from 'react-youtube'

import clsx from 'clsx'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import {
  Typography,
  EnumTypographyVariants,
} from 'src/common/components/Typography/Typography'

import s from './AboutBuildingBlock.module.scss'

export type AboutBuildingBlockProps = {}

export const AboutBuildingBlock: React.FC<AboutBuildingBlockProps> = () => {
  return (
    <ContentSection className={s.AboutBuildingBlock}>
      <div
        className={clsx(s.AboutBuildingBlock__block, s.AboutBuildingBlock__img)}
      >
        <YouTube
          videoId="oZcvT6V0Bqg"
          opts={{ autoplay: true, width: '100%', height: '100%' }}
        />
      </div>

      <div className={s.AboutBuildingBlock__block}>
        <Typography
          variant={EnumTypographyVariants.H2}
          text="Why are we building Insquad"
          className={s.AboutBuildingBlock__title}
        />

        <Typography
          variant={EnumTypographyVariants.H6}
          as="p"
          text="We believe that startups will be at the forefront of efforts to improve diversity in the tech industry and transition to a new business reality. And very soon a developer’s income will be determined not by location-based privilege, but just by their talent. By connecting talents and startups’ CEOs with ambitious tasks, our goal is to help build a fair, accessible work environment all over the world."
        />
      </div>
    </ContentSection>
  )
}
